import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import { SubscriptionType } from '../../../models/subscription/subscription-details.js';
import '../../../models/checkoutState/checkoutState.js';
import '@swc/helpers';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import '@grandvisionhq/utils';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/graphql';
import '../../../utils/get-unrecoverable-validation-errors.js';
import { isContactLensesSubscriptionLineItem } from '../../../utils/is-contact-lenses-subscription-line-item.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import { MainTotal } from '../components/MainTotal.js';
import { SubscriptionExplainer } from '../components/SubscriptionExplainer.js';
import { Subtotal } from '../components/Subtotal.js';
import 'classnames';
import '@grandvisionhq/iris-ui';
import { getSubscriptionLabels } from '../utils/get-subscription-labels.js';

const SubscriptionContainer = ({ lineItems , subscription , hideSubscriptionExplainer  })=>{
    const { currency , getLabel , getFormattedLabel  } = useIntl();
    const contactLensesSubscriptionLineItem = lineItems.find((lineItem)=>lineItem.type === 'contact-lenses-subscription'
    );
    const labels = React.useMemo(()=>({
            totalPerMonth: getLabel('cart.subscription.totalPerMonth'),
            totalPerThreeMonths: getLabel('cart.subscription.totalPerThreeMonths'),
            firstPayment: getLabel('cart.subscription.firstPayment'),
            subscriptionExplainer: {
                monthly: getFormattedLabel('cart.subscription.explainerMonthly', {
                    labelData: {
                        billingDate: subscription.billingDate
                    }
                }),
                quarterly: getFormattedLabel('cart.subscription.explainerQuarterly', {
                    labelData: {
                        billingDate: subscription.billingDate
                    }
                }),
                mixedMonthly: getFormattedLabel('cart.subscription.explainerMixedMonthly', {
                    labelData: {
                        billingDate: subscription.billingDate
                    }
                }),
                mixedQuarterly: getFormattedLabel('cart.subscription.explainerMixedQuarterly', {
                    labelData: {
                        billingDate: subscription.billingDate
                    }
                })
            }
        })
    , [
        getLabel,
        getFormattedLabel,
        subscription.billingDate
    ]);
    if (!contactLensesSubscriptionLineItem || !isContactLensesSubscriptionLineItem(contactLensesSubscriptionLineItem)) {
        return null;
    }
    const hasFirstPayment = contactLensesSubscriptionLineItem.subscriptionType === SubscriptionType.MIXED_MONTHLY;
    const { totals , explainer  } = getSubscriptionLabels(contactLensesSubscriptionLineItem.subscriptionType, labels);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, hasFirstPayment && /*#__PURE__*/ React.createElement(Subtotal, {
        label: labels.firstPayment,
        price: subscription.firstPayment,
        currency: currency
    }), /*#__PURE__*/ React.createElement(MainTotal, {
        label: totals,
        price: subscription.recurringPayment,
        currency: currency
    }), !hideSubscriptionExplainer && /*#__PURE__*/ React.createElement(SubscriptionExplainer, {
        information: explainer
    }));
};

export { SubscriptionContainer };
//# sourceMappingURL=SubscriptionContainer.js.map
